import { SearchResultItem } from '../models/search'

const professionalCsvFields = [
  'created_at',
  'updated_at',
  'lead_created_at',
  'funnel_created_at_year',
  'funnel_created_at_month',
  'funnel_created_at_day',
  'first_name',
  'last_name',
  'email',
  'phone_number',
  'profession',
  'experience_level',
  'work_region_codes',
  'primary_parent_region',
  'registration_state',
  'registration_steps_left',
  'interview_state',
  'background_check_state',
  'w9_status',
  'participation_state',
  'activity_level',
  'specialty_free_form',
  'last_shift_agreement_at',
  'preferred_facility_types',
  'fav_count',
  'dnr_count',
  'overall_reviews_rating',
  'total_booked_shifts',
  'total_shifts_worked',
  'indicated_positions',
  'qualified_positions',
  'referral_code',
  'assigned_referral_code',
  'marketing_channel',
  'referral_and_marketing_channel',
  'interviewer',
  'newsletter_opt_in',
  'biz_focus',
  'address',
  'has_worked_hospital_shifts',
  'professional_id',
  'user_id',
  'persona_id'
]

const professionalLeadCsvFields = [
  'created_at',
  'updated_at',
  'created_at_year',
  'created_at_month',
  'created_at_day',
  'first_name',
  'last_name',
  'email',
  'phone_number',
  'ip_address_state',
  'ip_address_city',
  'parent_regions',
  'profession',
  'experience_level',
  'primary_child_regions',
  'secondary_child_regions',
  'primary_country_subdivision',
  'secondary_country_subdivisions',
  'duplicate',
  'state',
  'waitlisted_interview_reason',
  'follow_up_on',
  'interview_state',
  'interview_offered_at',
  'interview_scheduled_at',
  'resume_available',
  'external_resume_url',
  'indicated_positions',
  'referral_code',
  'marketing_channel',
  'referral_and_marketing_channel',
  'newsletter',
  'onboarding_manager_user',
  'talent_manager',
  'document_reviewer',
  'license_number',
  'license_state',
  'license_expires_on',
  'license_received_on',
  'tools_link',
  'worked_shifts',
  'viewed_shifts',
  'professional_id',
  'user_id'
]

export class CsvService {

  fromProfessionalDiscoveries = (discoveries: Array<SearchResultItem>) => {
    return discoveries.map(this.professionalDiscoveryToCsv).join('\n')
  }

  fromProfessionalLeadDiscoveries = (discoveries: Array<SearchResultItem>) => {
    return discoveries.map(this.professionalLeadDiscoveryToCsv).join('\n')
  }

  private professionalDiscoveryToCsv = (discovery: SearchResultItem) => {
    return professionalCsvFields.map((field) => discovery.details.hasOwnProperty(field) ? `"${discovery.details[field] || "" }"` : '').join(',')
  }

  private professionalLeadDiscoveryToCsv = (discovery: SearchResultItem) => {
    return professionalLeadCsvFields.map((field) => discovery.details.hasOwnProperty(field) ? `"${discovery.details[field] || "" }"` : '').join(',')
  }

}
